//#region IMPORT
import React from 'react';
/** Components Import */
import { Unstable_Grid2 as Grid, Box, Tabs, Tab } from '@mui/material';
import { AuthButton } from '../../../../Components/MUIs';
import { PropTypes } from 'prop-types';
/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import WOR_BASIC_01F from '../WOR_BASIC_01/WOR_BASIC_01F';
import WOR_BASIC_02F from '../WOR_BASIC_02/WOR_BASIC_02F';
import WOR_BASIC_03F from '../WOR_BASIC_03/WOR_BASIC_03F';
//#endregion

function A11yProps(index) {
  return {
    id: `wor-basic-tab-${index}`,
    'aria-controls': `wor-basic-tabpanel-${index}`,
  };
}

function CustomTabPanel(props) {
  const { children, value, index } = props;
  return (
    <React.Fragment>
      {value === index && (
        <Box sx={{ width: '100%', height: '100%', minHeight: 0 }}>
          {children}
        </Box>
      )}
    </React.Fragment>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function WOR_BASIC(props) {
  const conditionsTab0 = [
    ...(props.userInfo?.authCd === 'ADMIN'
      ? [
          {
            type: 'combo',
            name: '회사',
            items: props.searchInfo.coList,
            value: props.searchInfo.coCd,
            onChange: (e) => {
              props.handleCoChange(e);
              if (!props.validateSelection()) return;
              props.setSearchClick1?.(true);
            },
          },
        ]
      : []),
    {
      type: 'combo',
      name: '사업장',
      items: props.searchInfo.custList,
      value: props.searchInfo.custCd,
      onChange: (e) => {
        if (!props.validateSelection()) return;
        props.handleCustChange(e);
        props.setSearchClick1?.(true);
      },
    },
    {
      type: 'combo',
      name: '연도',
      items: props.yearList || [],
      value: props.selectedYear ?? '',
      onChange: (e) => {
        props.setSelectedYear(e?.target?.value ?? e);
        if (!props.validateSelection()) return;
        props.setSearchClick1?.(true);
      },
    },
  ];

  const conditionsTab1 = [
    ...(props.userInfo?.authCd === 'ADMIN'
      ? [
          {
            type: 'combo',
            name: '회사',
            items: props.searchInfo.coList,
            value: props.searchInfo.coCd,
            onChange: (e) => {
              props.handleCoChange(e);
              if (!props.validateSelection()) return;
              props.setSearchClick1?.(true);
            },
          },
        ]
      : []),
    {
      type: 'combo',
      name: '사업장',
      items: props.searchInfo.custList,
      value: props.searchInfo.custCd,
      onChange: (e) => {
        if (!props.validateSelection()) return;
        props.handleCustChange(e);
        if (props.value === 2) props.setSearchClick3?.(true);
        else props.setSearchClick2?.(true);
      },
    },
  ];

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="WorkEnvironment"
          saveYn="Y"
          printYn={props.value === 2 ? 'N' : 'Y'}
          saveClick={() => {
            if (!props.validateSelection()) return;
            if (props.value === 0) props.setSaveClick1(true);
            else if (props.value === 1) props.setSaveClick2(true);
            else if (props.value === 2) props.setSaveClick3(true);
          }}
          deleteClick={() => {
            if (!props.validateSelection()) return;
            if (props.value === 0) props.setDeleteClick1(true);
            else if (props.value === 1) props.setDeleteClick2(true);
            else if (props.value === 2) props.setDeleteClick3(true);
          }}
          searchClick={() => {
            if (!props.validateSelection()) return;
            if (props.value === 0) props.setSearchClick1(true);
            else if (props.value === 1) props.setSearchClick2(true);
            else if (props.value === 2) props.setSearchClick3(true);
          }}
          printClick={() => {
            if (!props.validateSelection()) return;
            if (props.value === 0) props.setPrintClick1(true);
            else if (props.value === 1) props.setPrintClick2(true);
            else if (props.value === 2) props.setPrintClick3(true);
          }}
          conditions={props.value === 0 ? conditionsTab0 : conditionsTab1}
          grids={
            <React.Fragment>
              <Box>
                <Tabs
                  value={props.value}
                  onChange={props.HandleChange}
                  aria-label="작업환경측정 탭"
                >
                  <Tab
                    label="작업환경측정"
                    {...A11yProps(0)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="대상물질"
                    {...A11yProps(1)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="보고서"
                    {...A11yProps(2)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                </Tabs>
              </Box>
              <CustomTabPanel value={props.value} index={0}>
                <WOR_BASIC_01F
                  selectedYear={props.selectedYear}
                  filterClick1={props.filterClick1}
                  setFilterClick1={props.setFilterClick1}
                  searchClick1={props.searchClick1}
                  setSearchClick1={props.setSearchClick1}
                  addClick1={props.addClick1}
                  setAddClick1={props.setAddClick1}
                  saveClick1={props.saveClick1}
                  setSaveClick1={props.setSaveClick1}
                  deleteClick1={props.deleteClick1}
                  setDeleteClick1={props.setDeleteClick1}
                  printClick1={props.printClick1}
                  setPrintClick1={props.setPrintClick1}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={1}>
                <WOR_BASIC_02F
                  filterClick2={props.filterClick2}
                  setFilterClick2={props.setFilterClick2}
                  searchClick2={props.searchClick2}
                  setSearchClick2={props.setSearchClick2}
                  addClick2={props.addClick2}
                  setAddClick2={props.setAddClick2}
                  saveClick2={props.saveClick2}
                  setSaveClick2={props.setSaveClick2}
                  deleteClick2={props.deleteClick2}
                  setDeleteClick2={props.setDeleteClick2}
                  printClick2={props.printClick2}
                  setPrintClick2={props.setPrintClick2}
                  gridId={props.gridId1}
                  dispatch={props.dispatch}
                  showSnackbar={props.showSnackbar}
                  DownloadLogic1={props.DownloadLogic1}
                  DownloadLogic2={props.DownloadLogic2}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={2}>
                <WOR_BASIC_03F
                  searchInfo={props.searchInfo}
                  filterClick1={props.filterClick3}
                  setFilterClick1={props.setFilterClick3}
                  searchClick1={props.searchClick3}
                  setSearchClick1={props.setSearchClick3}
                  saveClick1={props.saveClick3}
                  setSaveClick1={props.setSaveClick3}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
            </React.Fragment>
          }
        />
      </Grid>
    </Grid>
  );
}

export default WOR_BASIC;
